/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import DatePickerToggle from '../../../components/DatePickerToggle';
import FuzzyDateRange from '../../../components/FuzzyDateRange';
import Spacer from '../../../components/Spacer';
import { TimeFromNow } from '../../../localization/LocalizedDate';
import { Inputs } from '../../../../bphComponents/bundle';

interface Props {
  allowTogglePeriod: boolean;
  startDate: string;
  endDate: string;
  startDatePrecision: string;
  endDatePrecision: string;
  hasInitialFocus?: boolean;
  isPeriod: boolean;
  isPeriodChoices: any[];
  onChangeStartDate(d): void;
  onFocusStartDate(): void;
  onCancelStartDate(): void;
  onChangeEndDate(d): void;
  onFocusEndDate(): void;
  onCancelEndDate(): void;
  toggleIsPeriod(): void;
  earliestDateLimit: string;
  latestDateLimit: string;
  warningHint: string;
  earliestDateWarningLimit: string;
}

export const HealthEntryWhenPast: React.FC<Props> = (props) => (
  <>
    {
      props.allowTogglePeriod && (
        <Inputs.ToggleSwitch.ProfileThemedToggleSwitch
          value={props.isPeriod}
          choices={props.isPeriodChoices}
          onChange={props.toggleIsPeriod}
          isOff={!props.isPeriod}
        />
      )
    }

    <Spacer size="9" />

    {
      props.isPeriod ? (
        <FuzzyDateRange {...props} />
      ) : (
        <DatePickerToggle
          label="pastDates.date.field.label"
          date={props.startDate}
          precision={props.startDatePrecision}
          name="start_date"
          onChange={props.onChangeStartDate}
          isFuzzy
          hasToday
          allowNull
          initialFocus={props.hasInitialFocus}
          onFocus={props.onFocusStartDate}
          onCancel={props.onCancelStartDate}
          earliestDateLimit={props.earliestDateLimit}
          latestDateLimit={props.latestDateLimit}
          warningHint={props.warningHint}
          earliestDateWarningLimit={props.earliestDateWarningLimit}
          regularHint={
            <TimeFromNow
              dateData={{
                date: props.startDate,
                precision: props.startDatePrecision,
              }}
            />
          }
        />
      )
    }
  </>
);
